import { dashboardApi } from "@services";
import { createSlice } from "@reduxjs/toolkit";
import { IBusinessUnitState } from "@types";

const initialState: IBusinessUnitState = {
  list: [],
};

const slice = createSlice({
  name: "dashboardUnit",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(
      dashboardApi.endpoints.fetchFilters.matchFulfilled,
      (state, { payload }) => {
        state.list = payload.data;
      }
    );
  },
});

export default slice.reducer;
